// extracted by mini-css-extract-plugin
module.exports = {"htLogo":"ckuGiyhKPlF7FOeN1tZc9w==","defaultCursor":"wpYm01RDFTluR0tOT5kPMg=="};